<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Twitter" class="d-icon d-icon--twitter" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8.66 19.626c6.793 0 10.508-5.628 10.508-10.508 0-.16 0-.319-.01-.477A7.513 7.513 0 0 0 21 6.729a7.372 7.372 0 0 1-2.121.581 3.706 3.706 0 0 0 1.623-2.042 7.4 7.4 0 0 1-2.345.896 3.696 3.696 0 0 0-6.293 3.368 10.485 10.485 0 0 1-7.611-3.858 3.696 3.696 0 0 0 1.143 4.93 3.665 3.665 0 0 1-1.676-.463v.047a3.695 3.695 0 0 0 2.963 3.62 3.687 3.687 0 0 1-1.668.064 3.697 3.697 0 0 0 3.45 2.564A7.41 7.41 0 0 1 3 17.967a10.456 10.456 0 0 0 5.66 1.656" fill="#1DA1F2"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconTwitter',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
